module.exports = __webpack_public_path__ + "74f0c791df7df00d0ef18b81efc64c60.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg4.jpeg
// module id = 50
// module chunks = 0